import React from 'react';
import { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Drawer, AppBar, Toolbar, Tooltip, IconButton } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import DrawerHeader from '../../../atoms/drawerHeader';
import { useDispatch } from 'react-redux';
import UpdateCancel from "../../../atoms/buttons/UpdateCancel";
import AssetsExplorer from "./AssetsExplorer";
import { setImageMapData } from "../../../../store/global/actions";

const drawerWidth = 500;

const useStyles = makeStyles((theme) => ({
    assetsDrawer: {
        overflow: 'auto',
        width: drawerWidth,
        backgroundColor: '#fff',
        marginTop: '8rem',
        height: 'calc(100vh - 128px)', // 128 = topbar (64) + bottom drawer topbar (64) 
        boxShadow: '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)',
        zIndex: 1000
    },
    buttonContainer: {
        display: "flex",
        justifyContent: "flex-end",
        marginBottom: '0.625rem',
        marginRight: '0.625rem',
    },
    mainContainer: {
        minHeight: 'calc(100vh - 256px)',  // 256 = topbar (64) + bottom drawer topbar (64) + asset explorer topbar (64) + breadcrumb (64)
        padding: 15
    },

}));

export default function AssetsExplorerDrawer({ open, onClose }) {

    const classes = useStyles();
    const dispatch = useDispatch();

    const [selectedFile, setSelectedFile] = useState(undefined);
    const [drawerType, setDrawerType] = useState(null)

    const onOpenImage = () => {
        if (selectedFile === undefined) {
            return;
        }
        dispatch(setImageMapData({ url: selectedFile.filePath, asset: selectedFile, areas: [] }));
        onClose();
    }

    return (
        <Drawer
            className={classes.areaListDrawer}
            anchor="right"
            open={open}
            disablePortal
            hideBackdrop
            classes={{
                paper: classes.assetsDrawer,
            }}
            style={{top: '128px'}}
            id={"imageMapAssetDrawer"}
        >
            <AppBar position="static">
                <Toolbar>
                    <Grid container>
                        <Grid item xs={10} align={'center'} direction={'column'} justify={'center'}>
                            <h5 style={{ marginTop: 10 }}><DrawerHeader name="Assets" /> </h5>
                        </Grid>
                        <Grid item xs={2} style={{ textAlign: 'right' }}>
                            <Tooltip title="Close assets explorer">
                                <IconButton onClick={onClose}><CancelIcon /></IconButton>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>


            
            <Grid container direction={"row"}>
                {open &&
                    <Grid item xs={12} className={classes.mainContainer}>
                        <AssetsExplorer 
                            setSelectedFile={setSelectedFile} 
                            selectedFile={selectedFile} 
                            drawerType={drawerType} 
                            setDrawerType={setDrawerType} 
                        />
                    </Grid>
                }
                {
                    !drawerType &&
                    <Grid item xs={12} className={classes.buttonContainer}>
                        <UpdateCancel updateDisable={selectedFile === undefined} onUpdate={onOpenImage} content={"Open"} onCancel={onClose} typesNotIn={['view']} />
                    </Grid>
                }
            </Grid>
            
        </Drawer>
    );
}


